import styled from 'styled-components'
import { pxToRem } from 'styles/functions'

export const StyledContainer = styled.div`
    margin: ${pxToRem(20)};
`

interface StyledTextProps {
    theme: any;
}
export const StyledText = styled.div<StyledTextProps>`
    font-size: ${({ theme }) => (theme.text_size ? pxToRem(theme.text_size) : '14px')};
    line-height: ${({ theme }) => (theme.text_lineheight ? pxToRem(theme.text_lineheight) : '22px')};
    word-wrap: break-word;

    p {
        margin: 0 !important;
        ${({ theme }) =>
          theme.custom_paragraph_missionbiorobotique && theme.custom_paragraph_missionbiorobotique};
    }
    ol {
        margin-left: ${({ theme }) => (theme.text_margin_left ? pxToRem(theme.text_margin_left) : '40px')};
        list-style-type: ${({ theme }) => (theme.text_list_style_type ? theme.text_list_style_type : 'decimal')};
    }
    ul {
        margin-left: ${({ theme }) => (theme.text_margin_left ? pxToRem(theme.text_margin_left) : '40px')};
        list-style-type: ${({ theme }) => (theme.text_list_style_type ? theme.text_list_style_type : 'disc')};
    }
    a {
        text-decoration: ${({ theme }) => (theme.text_text_decoration ? theme.text_text_decoration : 'underline')};
    }
`
